import mediasReducer from "./mediasSlice";
import mediaReducer from "./mediaSlice";

const media = {
  medias: mediasReducer,
  media: mediaReducer,
};

export default media;
